import { styled } from '@robocorp/theme';
import { IconDocker, IconGithub, IconGitlab, IconGitMerge, IconTerminal } from '@robocorp/icons';
import { IconLogoRobocorp } from '@robocorp/icons/logos';
import {
  ActivityTemplate,
  CompletedS3Source,
} from '@robocorp/robocloud-internal-cds-sdk/lib/src/types/RcInstanceDB';
import { FunctionComponent } from 'react';
import { isGitlabSource } from '~/utils/robotHelper';

interface Props {
  robot?: ActivityTemplate;
  type?: 'git' | 'github' | 'gitlab' | 'file' | 'cmdOnly';
}

const IconStyled = styled.div`
  display: block;
  width: 24px;
  height: 24px;
  padding: 4px;
  background: ${({ theme }) => theme.color('background.subtle.light')};
  border-radius: 2px;
  margin-right: 8px;
`;

const RobotIcon: FunctionComponent<Props> = ({ robot, type }) => {
  let Icon = IconTerminal;

  const isGitlabType = type === 'gitlab' || isGitlabSource(robot);

  if ((robot?.config as CompletedS3Source)?.imageUri) {
    Icon = IconDocker;
  } else if (isGitlabType) {
    Icon = IconGitlab;
  } else if (robot?.config.gitInfo?.gitHubInstallationId || type === 'github') {
    Icon = IconGithub;
  } else if (robot?.config.gitInfo || type === 'git') {
    Icon = IconGitMerge;
  } else if (robot?.config.sourceType === 's3' || type === 'file') {
    Icon = IconLogoRobocorp;
  }

  return (
    <IconStyled>
      <Icon size={16} color="grey20" />
    </IconStyled>
  );
};

export default RobotIcon;
